var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "scrollList",
      staticClass: "sc-message-list",
      style: { backgroundColor: _vm.colors.messageList.bg },
      on: { scroll: _vm.handleScroll }
    },
    [
      _vm._l(_vm.messages, function(message, idx) {
        return _c("Message", {
          key: idx,
          attrs: {
            message: message,
            user: _vm.profile(message.author),
            colors: _vm.colors,
            messageStyling: _vm.messageStyling
          },
          on: {
            remove: function($event) {
              return _vm.$emit("remove", message)
            }
          },
          scopedSlots: _vm._u(
            [
              {
                key: "user-avatar",
                fn: function(scopedProps) {
                  return [
                    _vm._t("user-avatar", null, {
                      user: scopedProps.user,
                      message: scopedProps.message
                    })
                  ]
                }
              },
              {
                key: "text-message-body",
                fn: function(scopedProps) {
                  return [
                    _vm._t("text-message-body", null, {
                      message: scopedProps.message,
                      messageText: scopedProps.messageText,
                      messageColors: scopedProps.messageColors,
                      me: scopedProps.me
                    })
                  ]
                }
              },
              {
                key: "text-message-toolbox",
                fn: function(scopedProps) {
                  return [
                    _vm._t("text-message-toolbox", null, {
                      message: scopedProps.message,
                      me: scopedProps.me
                    })
                  ]
                }
              }
            ],
            null,
            true
          )
        })
      }),
      _vm._v(" "),
      _c("Message", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showTypingIndicator !== "",
            expression: "showTypingIndicator !== ''"
          }
        ],
        attrs: {
          message: { author: _vm.showTypingIndicator, type: "typing" },
          user: {},
          colors: _vm.colors,
          messageStyling: _vm.messageStyling
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f6f9094", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f6f9094","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-beautiful-chat/src/MessageList.vue
// module id = 1918
// module chunks = 116